"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMarketTemplate = exports.selectOddStatistic = exports.selectSport = exports.selectTournamentByIdFromProps = exports.selectTournamentBySportEvent = exports.selectTournament = exports.selectOdd = exports.selectMarket = exports.selectMatch = exports.selectUsersFreeBetCount = exports.selectAllCashOutOrders = exports.selectAllScores = exports.selectAllMeta = exports.selectOddsStatisticMarkets = exports.selectOddsStatistic = exports.selectSlugs = exports.selectFreezedOdds = exports.selectAllBetOdds = exports.selectAllFreeBets = exports.selectAllMarketTemplates = exports.selectAllTeams = exports.selectAllCompetitors = exports.selectPlayers = exports.selectStreams = exports.selectSports = exports.selectBets = exports.selectTournaments = exports.selectOdds = exports.selectMarkets = exports.selectMatches = exports.selectAll = exports.selectPathnameFromProps = exports.selectBetIdsFromProps = exports.selectCashOutOrderIdFromProps = exports.selectBetIdFromProps = exports.selectSportIdFromProps = exports.selectSportTypeFromProps = exports.selectMarketTemplateIdsFromProps = exports.selectMarketTemplateIdFromProps = exports.selectTournamentIdFromProps = exports.selectOddIdsFromProps = exports.selectOddIdFromProps = exports.selectMarketIdFromProps = exports.selectSlugFromProps = exports.selectMatchIdFromProps = exports.selectTournamentIdFromParams = exports.selectEntities = exports.selectSportEventIdsFromProps = exports.selectLocationFromProps = exports.createShallowEqualSelector = void 0;
exports.selectBetCashOutOrder = exports.selectCachedBet = exports.selectTemplatesByIds = exports.selectMarketTypeIdsByMarketIds = exports.makeSelectShallowMarketsWithOddsByIds = exports.selectMarketsWithOddsByIds = exports.makeShallowMarketsByIds = exports.selectMarketsByIds = exports.selectMarketIdsFromProps = exports.selectMissingSportEventIds = exports.selectSportBySlug = exports.selectSportById = exports.selectSportByTournament = exports.selectSportBySportEvent = exports.makeSelectSportByEntry = exports.selectSportTypeBySports = exports.selectSportTypeFromLocation = exports.selectSportsBySportType = exports.selectStatisticPercentsByMarket = exports.selectStatisticPercentsByMatch = exports.selectMarketTemplatesByIds = exports.selectActiveOddIds = exports.selectOddsByOddIds = exports.selectFirstMarketIdFromMatch = exports.selectMobileMatchStream = exports.selectSumOfOdds = exports.makeEntitySelector = exports.createSelectAll = exports.selectOddWithAvailability = exports.makeOddsByMarketSelector = exports.makeDebugInfoSelector = exports.makeMarketSelector = exports.makeMatchSelector = exports.selectSportFromMatch = exports.selectMatchCompetitorsValid = exports.makeSelectMatchViewScores = exports.selectScoresByMatch = exports.selectCompetitorsByMatch = exports.selectMatchMetaValueByName = exports.selectMatchMeta = exports.selectPreviewTournamentIdFromMatch = exports.selectPreviewMarketIdFromMatch = exports.makeMarketIdSelector = exports.selectMatchCompetitorIds = exports.makeTournamentSelector = exports.selectTournamentInMatch = exports.selectSlugByMatchId = exports.selectSlug = void 0;
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var re_reselect_1 = __importDefault(require("re-reselect"));
var reselect_1 = require("reselect");
var types_1 = require("../types");
var utils_1 = require("../utils");
var selectors_1 = require("../viewport/selectors");
var constants_1 = require("./constants");
exports.createShallowEqualSelector = reselect_1.createSelectorCreator(reselect_1.defaultMemoize, function (a, b) {
    return utils_1.checkEquality(a, b, {
        maxDepth: 1,
    });
});
var selectLocationFromProps = function (_, props) { return props.location; };
exports.selectLocationFromProps = selectLocationFromProps;
var selectSportEventIdsFromProps = function (_, props) {
    return props.sportEventIds;
};
exports.selectSportEventIdsFromProps = selectSportEventIdsFromProps;
var selectEntities = function (state) { return state.get(constants_1.NAME); };
exports.selectEntities = selectEntities;
var selectTournamentIdFromParams = function (_, props) {
    return props.match && props.match.params.tournamentId;
};
exports.selectTournamentIdFromParams = selectTournamentIdFromParams;
var selectMatchIdFromProps = function (_, props) { return props.matchId; };
exports.selectMatchIdFromProps = selectMatchIdFromProps;
var selectSlugFromProps = function (_, props) { return props.slug; };
exports.selectSlugFromProps = selectSlugFromProps;
var selectMarketIdFromProps = function (_, props) { return props.marketId; };
exports.selectMarketIdFromProps = selectMarketIdFromProps;
var selectOddIdFromProps = function (_, props) { return props.oddId; };
exports.selectOddIdFromProps = selectOddIdFromProps;
var selectOddIdsFromProps = function (_, props) {
    if (immutable_1.OrderedSet.isOrderedSet(props.oddIds)) {
        return props.oddIds.toArray();
    }
    return props.oddIds;
};
exports.selectOddIdsFromProps = selectOddIdsFromProps;
var selectTournamentIdFromProps = function (_, props) {
    return props.tournamentId;
};
exports.selectTournamentIdFromProps = selectTournamentIdFromProps;
var selectMarketTemplateIdFromProps = function (_, props) {
    return props.marketTemplateId;
};
exports.selectMarketTemplateIdFromProps = selectMarketTemplateIdFromProps;
var selectMarketTemplateIdsFromProps = function (_, props) {
    return props.marketTemplateIds;
};
exports.selectMarketTemplateIdsFromProps = selectMarketTemplateIdsFromProps;
var selectSportTypeFromProps = function (_, props) {
    return props.sportType;
};
exports.selectSportTypeFromProps = selectSportTypeFromProps;
var selectSportIdFromProps = function (_, _a) {
    var sportId = _a.sportId;
    return sportId;
};
exports.selectSportIdFromProps = selectSportIdFromProps;
var selectBetIdFromProps = function (_, props) { return props.betId; };
exports.selectBetIdFromProps = selectBetIdFromProps;
var selectCashOutOrderIdFromProps = function (_, props) { return props.cashOutOrderId; };
exports.selectCashOutOrderIdFromProps = selectCashOutOrderIdFromProps;
var selectBetIdsFromProps = function (_state, props) { return props.betIds; };
exports.selectBetIdsFromProps = selectBetIdsFromProps;
var selectPathnameFromProps = function (_, props) { return props.pathname; };
exports.selectPathnameFromProps = selectPathnameFromProps;
exports.selectAll = createSelectAll();
// TODO: export for backward compatibility, remove later
exports.selectMatches = exports.selectAll.matches;
exports.selectMarkets = exports.selectAll.markets;
exports.selectOdds = exports.selectAll.odds;
exports.selectTournaments = exports.selectAll.tournaments;
exports.selectBets = exports.selectAll.bets;
exports.selectSports = exports.selectAll.sports;
exports.selectStreams = exports.selectAll.streams;
exports.selectPlayers = exports.selectAll.players;
exports.selectAllCompetitors = exports.selectAll.competitors;
exports.selectAllTeams = exports.selectAll.teams;
exports.selectAllMarketTemplates = exports.selectAll.marketTemplates;
exports.selectAllFreeBets = exports.selectAll.freebets;
exports.selectAllBetOdds = exports.selectAll.betOdds;
exports.selectFreezedOdds = exports.selectAll.freezedOdds;
exports.selectSlugs = exports.selectAll.slugs;
exports.selectOddsStatistic = exports.selectAll.oddsStatistic;
exports.selectOddsStatisticMarkets = exports.selectAll.oddsStatisticMarkets;
exports.selectAllMeta = exports.selectAll.meta;
exports.selectAllScores = exports.selectAll.scores;
exports.selectAllCashOutOrders = exports.selectAll.cashOutOrders;
exports.selectUsersFreeBetCount = reselect_1.createSelector(exports.selectAllFreeBets, function (freebets) { return freebets.size; });
exports.selectMatch = makeEntitySelector('matches', exports.selectMatchIdFromProps);
exports.selectMarket = makeEntitySelector('markets', exports.selectMarketIdFromProps);
exports.selectOdd = makeEntitySelector('odds', exports.selectOddIdFromProps);
exports.selectTournament = makeEntitySelector('tournaments', exports.selectTournamentIdFromParams);
exports.selectTournamentBySportEvent = reselect_1.createSelector(exports.selectMatch, exports.selectTournaments, function (sportEvent, tournaments) {
    return sportEvent ? tournaments.get(sportEvent.tournament) : undefined;
});
exports.selectTournamentByIdFromProps = makeEntitySelector('tournaments', exports.selectTournamentIdFromProps);
exports.selectSport = makeEntitySelector('sports', exports.selectSportIdFromProps);
exports.selectOddStatistic = makeEntitySelector('oddsStatistic', exports.selectOddIdFromProps);
exports.selectMarketTemplate = makeEntitySelector('marketTemplates', exports.selectMarketTemplateIdFromProps);
exports.selectSlug = makeEntitySelector('slugs', exports.selectSlugFromProps);
exports.selectSlugByMatchId = reselect_1.createSelector(exports.selectMatch, function (match) {
    return match ? match.slug : null;
});
exports.selectTournamentInMatch = reselect_1.createSelector(exports.selectMatch, exports.selectAll.tournaments, function (match, tournaments) {
    if (!match)
        return null;
    return tournaments.get(match.tournament) || null;
});
function makeTournamentSelector(options) {
    if (options === void 0) { options = {}; }
    var propsToPick = options.propsToPick, _a = options.selectTournamentId, selectTournamentId = _a === void 0 ? exports.selectTournamentIdFromProps : _a;
    return reselect_1.createSelector(exports.selectAll.tournaments, selectTournamentId, function (allTournaments, tournamentId) {
        if (!tournamentId)
            return null;
        var tournament = allTournaments.get(tournamentId);
        if (!tournament)
            return null;
        if (propsToPick && propsToPick.length > 0) {
            return lodash_1.pick(tournament, propsToPick);
        }
        return tournament;
    });
}
exports.makeTournamentSelector = makeTournamentSelector;
exports.selectMatchCompetitorIds = reselect_1.createSelector(exports.selectMatch, function (match) {
    return match ? match.competitors : [];
});
var makeMarketIdSelector = function (options) {
    var selectTargetMatch = function () { return undefined; };
    if (options.selectMatch) {
        selectTargetMatch = exports.selectMatch;
    }
    else if (options.selectMatchId) {
        selectTargetMatch = makeEntitySelector('matches', options.selectMatchId);
    }
    return reselect_1.createSelector(selectTargetMatch, exports.selectAll.markets, function (match, markets) {
        // TODO: optimize, dont use market entities
        if (!match || match.markets.length === 0)
            return '';
        var priority = Infinity;
        var targetId = '';
        lodash_1.forEach(match.markets, function (marketId) {
            var market = markets.get(marketId);
            if (!market ||
                ![
                    types_1.GQL.MarketStatus.ACTIVE,
                    types_1.GQL.MarketStatus.SUSPENDED,
                ].includes(market.status)) {
                return;
            }
            if (market.priority === 1) {
                targetId = market.id;
                return false;
            }
            if (market.priority < priority) {
                targetId = market.id;
                priority = market.priority;
            }
        });
        return targetId;
    });
};
exports.makeMarketIdSelector = makeMarketIdSelector;
exports.selectPreviewMarketIdFromMatch = exports.makeMarketIdSelector({
    selectMatchId: exports.selectMatchIdFromProps,
});
exports.selectPreviewTournamentIdFromMatch = reselect_1.createSelector(exports.selectMatchIdFromProps, exports.selectAll.matches, function (matchId, allMatches) {
    var match = allMatches.get(matchId);
    if (!match)
        return null;
    return match.tournament || null;
});
exports.selectMatchMeta = reselect_1.createSelector(exports.selectMatch, exports.selectAllMeta, function (match, allMeta) {
    if (!match)
        return [];
    return lodash_1.compact(match.meta.map(function (id) { return allMeta.get(id); }));
});
exports.selectMatchMetaValueByName = reselect_1.createSelector(exports.selectMatchMeta, function (_, props) { return props.metaName; }, function (meta, metaName) {
    var metaItem = meta.find(function (m) { return m.name === metaName; });
    if (!metaItem)
        return null;
    return metaItem.value;
});
exports.selectCompetitorsByMatch = reselect_1.createSelector(exports.selectMatchCompetitorIds, exports.selectAllCompetitors, function (competitorIds, allCompetitors) {
    return lodash_1.compact(competitorIds.map(function (c_id) { return allCompetitors.get(c_id); }));
});
exports.selectScoresByMatch = reselect_1.createSelector(exports.selectCompetitorsByMatch, exports.selectAllScores, function (competitors, allScores) {
    var scoresInfo = [];
    competitors.map(function (competitor) {
        return competitor.score.forEach(function (scoreId) {
            var scoreEntity = allScores.get(scoreId);
            if (scoreEntity) {
                scoresInfo.push(__assign(__assign({}, scoreEntity), { homeAway: competitor.homeAway }));
            }
        });
    });
    return scoresInfo;
});
var makeSelectMatchViewScores = function (sportSortMapping, matchSelector) {
    if (matchSelector === void 0) { matchSelector = exports.selectMatch; }
    return reselect_1.createSelector(matchSelector, exports.selectScoresByMatch, function (match, matchScores) {
        var _a;
        var result = [];
        if (!match)
            return result;
        var sportId = match.sportId;
        var sortMap = sportSortMapping[sportId] || (_a = {},
            _a[types_1.App.ScoreTypes.TYPE_TOTAL] = 1,
            _a);
        var groupedByType = lodash_1.groupBy(matchScores, function (s) { return s.type; });
        lodash_1.forEach(groupedByType, function (group, groupName) {
            var groupCounter = 1;
            var groupedByPosition = lodash_1.groupBy(group, function (g) { return g.number; });
            lodash_1.forEach(groupedByPosition, function (groupByPosition) {
                var home = lodash_1.find(groupByPosition, [
                    'homeAway',
                    types_1.GQL.CompetitorHomeAway.HOME,
                ]);
                var away = lodash_1.find(groupByPosition, [
                    'homeAway',
                    types_1.GQL.CompetitorHomeAway.AWAY,
                ]);
                var indexNumberForTieBreak = away && home && away.number === home.number
                    ? away.number + 1
                    : null;
                var aggregatedScores = {
                    type: groupName,
                    home: home ? home.points : '-',
                    away: away ? away.points : '-',
                    indexNumber: groupName === types_1.App.ScoreTypes.TYPE_TIE_BREAK
                        ? lodash_1.isNull(indexNumberForTieBreak)
                            ? 0
                            : indexNumberForTieBreak
                        : groupCounter,
                };
                groupCounter++;
                result.push(aggregatedScores);
            });
        });
        result = result.filter(function (e) { return lodash_1.keys(sortMap).includes(e.type); });
        result.sort(function (a, b) {
            if (a.type === b.type) {
                return a.indexNumber - b.indexNumber;
            }
            return (sortMap[a.type] || 1) - (sortMap[b.type] || 0);
        });
        return result;
    });
};
exports.makeSelectMatchViewScores = makeSelectMatchViewScores;
// TODO: refactor, should return { away, home } or be configurable
exports.selectMatchCompetitorsValid = reselect_1.createSelector(exports.selectMatch, exports.selectAll.competitors, function (match, allCompetitors) {
    var result = {
        homeLogo: '',
        awayLogo: '',
        homeName: '',
        awayName: '',
        competitorType: types_1.GQL.CompetitorType.OTHER,
    };
    if (!match)
        return result;
    var competitorIds = match.competitors;
    competitorIds.forEach(function (competitorId) {
        var competitor = allCompetitors.get(competitorId);
        if (competitor) {
            result.competitorType = competitor.type;
            if (competitor.homeAway === types_1.GQL.CompetitorHomeAway.HOME) {
                result.homeLogo = competitor.logo;
                result.homeName = competitor.name;
            }
            else if (competitor.homeAway === types_1.GQL.CompetitorHomeAway.AWAY) {
                result.awayLogo = competitor.logo;
                result.awayName = competitor.name;
            }
        }
    });
    return result;
});
exports.selectSportFromMatch = reselect_1.createSelector(makeMatchSelector(), exports.selectAll.sports, function (match, sports) {
    if (!match)
        return '';
    var sportId = match.sportId;
    var sport = sports.get(sportId);
    return sport ? sport.name : '';
});
function makeMatchSelector(options) {
    if (options === void 0) { options = {}; }
    var propsToPick = options.propsToPick, _a = options.selectMatchId, selectMatchId = _a === void 0 ? exports.selectMatchIdFromProps : _a;
    return reselect_1.createSelector(exports.selectAll.matches, selectMatchId, function (allMatches, id) {
        if (!id)
            return null;
        var match = allMatches.get(id);
        if (!match)
            return null;
        if (propsToPick && propsToPick.length > 0) {
            return lodash_1.pick(match, propsToPick);
        }
        return match;
    });
}
exports.makeMatchSelector = makeMatchSelector;
function makeMarketSelector(options) {
    if (options === void 0) { options = {}; }
    var propsToPick = options.propsToPick, _a = options.selectMarketId, selectMarketId = _a === void 0 ? exports.selectPreviewMarketIdFromMatch : _a;
    return reselect_1.createSelector(exports.selectAll.markets, selectMarketId, function (allMarkets, id) {
        if (!id)
            return null;
        var market = allMarkets.get(id);
        if (!market)
            return null;
        if (propsToPick && propsToPick.length > 0) {
            return lodash_1.pick(market, propsToPick);
        }
        return market;
    });
}
exports.makeMarketSelector = makeMarketSelector;
function makeDebugInfoSelector(options) {
    if (options === void 0) { options = {}; }
    var _a = options.selectMarketId, selectMarketId = _a === void 0 ? exports.selectPreviewMarketIdFromMatch : _a;
    return reselect_1.createSelector(exports.selectAll.markets, selectMarketId, function (allMarkets, id) {
        if (!id)
            return '';
        var market = allMarkets.get(id);
        if (!market)
            return '';
        var _a = lodash_1.pick(market, [
            'specifiers',
            'typeId',
            'priority',
            'tags',
        ]), specifiers = _a.specifiers, typeId = _a.typeId, priority = _a.priority, tags = _a.tags;
        var marketSpecifiers = '';
        if (specifiers.length !== 0) {
            marketSpecifiers = specifiers.reduce(function (acc, currentSpecifier, i) {
                var next = "" + acc + currentSpecifier.name + ": " + currentSpecifier.value;
                next += i === specifiers.length - 1 ? ')' : ', ';
                return next;
            }, '(');
        }
        var strTags = tags.reduce(function (acc, tag) { return acc + " '" + tag + "'"; }, '');
        if (strTags) {
            strTags = "[" + strTags + "]";
        }
        return typeId + "; " + ("" + priority) + "; " + marketSpecifiers + (marketSpecifiers ? ';' : '') + " " + strTags;
    });
}
exports.makeDebugInfoSelector = makeDebugInfoSelector;
function makeOddsByMarketSelector(options) {
    var marketSelector = options.marketSelector, propsToPick = options.propsToPick;
    return reselect_1.createSelector(exports.selectAll.odds, marketSelector, function (allOdds, market) {
        if (!market || !market.odds)
            return [];
        var shouldPickOdd = propsToPick && propsToPick.length > 0;
        return lodash_1.reduce(market.odds, function (acc, oddId) {
            var odd = allOdds.get(oddId);
            if (!odd)
                return acc;
            if (shouldPickOdd) {
                var pickOdd = lodash_1.pick(odd, propsToPick);
                acc.push(pickOdd);
            }
            else {
                acc.push(odd);
            }
            return acc;
        }, []);
    });
}
exports.makeOddsByMarketSelector = makeOddsByMarketSelector;
exports.selectOddWithAvailability = reselect_1.createSelector(exports.selectOddIdFromProps, exports.selectOdds, exports.selectMatches, exports.selectMarkets, function (oddId, odds, matches, markets) {
    var ids = utils_1.getIdsFromOddId(oddId);
    var view = {
        odd: null,
        isActive: false,
    };
    if (!oddId || !ids)
        return view;
    var matchId = ids.matchId, marketId = ids.marketId;
    var odd = odds.get(oddId);
    if (!odd)
        return view;
    var isActive = utils_1.checkIsOddActiveByEntities({
        matches: matches,
        sportEventId: matchId,
        markets: markets,
        marketId: marketId,
        odds: odds,
        oddId: oddId,
    });
    return {
        odd: odd,
        isActive: isActive,
    };
});
function createSelectAll() {
    var entityNames = [
        'matches',
        'markets',
        'odds',
        'sports',
        'teams',
        'tournaments',
        'competitors',
        'bets',
        'players',
        'streams',
        'marketTemplates',
        'freebets',
        'betOdds',
        'freezedOdds',
        'slugs',
        'oddsStatisticMarkets',
        'oddsStatistic',
        'scores',
        'meta',
        'cashOutOrders',
    ];
    var all = {};
    lodash_1.forEach(entityNames, function (name) {
        all[name] = reselect_1.createSelector(exports.selectEntities, function (e) { return e.get(name); });
    });
    return Object.freeze(all);
}
exports.createSelectAll = createSelectAll;
function makeEntitySelector(name, selectId) {
    // let selectTargetEntities;
    // if (!selectAll) {
    //     console.warn(
    //         'Entities selectors map is not created, check calls order'
    //     );
    //     selectTargetEntities = createSelector(selectEntities, e => e.get(name));
    // } else {
    // selectTargetEntities = selectAll[name];
    // }
    var selectTargetEntities = exports.selectAll[name];
    return reselect_1.createSelector(selectTargetEntities, selectId, function (targetEntities, id) {
        if (id == null)
            return null;
        var entity = targetEntities.get(id);
        return entity !== undefined ? entity : null;
    });
}
exports.makeEntitySelector = makeEntitySelector;
exports.selectSumOfOdds = reselect_1.createSelector(exports.selectOddIdsFromProps, exports.selectOdds, function (oddIds, odds) {
    if (!oddIds || oddIds.length === 0)
        return 0;
    return oddIds.reduce(function (acc, oddId) {
        var odd = odds.get(oddId);
        if (odd)
            return acc * odd.value;
        console.warn("Can't find odd. OddId: " + oddId + " from ListComboOfTheDay");
        return acc;
    }, 1);
});
exports.selectMobileMatchStream = reselect_1.createSelector(exports.selectMatchIdFromProps, exports.selectMatches, exports.selectStreams, selectors_1.selectIsCompact, function (matchId, allMatches, allStreams, isCompact) {
    if (!matchId) {
        return null;
    }
    var match = allMatches.get(matchId);
    if (!match) {
        return null;
    }
    var streamIds = match.streams;
    return utils_1.getStreamWithCurrentLocale({
        allStreams: allStreams,
        streamIds: streamIds,
        isCompact: isCompact,
    });
});
exports.selectFirstMarketIdFromMatch = reselect_1.createSelector(exports.selectMatch, function (match) {
    if (!match)
        return null;
    return match.markets[0] || null;
});
exports.selectOddsByOddIds = reselect_1.createSelector(exports.selectOddIdsFromProps, exports.selectOdds, function (oddIds, odds) {
    return oddIds.map(function (oddId) { return odds.get(oddId); });
});
exports.selectActiveOddIds = reselect_1.createSelector(exports.selectOddIdsFromProps, exports.selectOdds, exports.selectMatches, exports.selectMarkets, function (oddIds, odds, matches, markets) {
    return oddIds.filter(function (oddId) {
        var ids = utils_1.getIdsFromOddId(oddId);
        if (!ids)
            return false;
        var marketId = ids.marketId, matchId = ids.matchId;
        return utils_1.checkIsOddActiveByEntities({
            marketId: marketId,
            sportEventId: matchId,
            oddId: oddId,
            markets: markets,
            matches: matches,
            odds: odds,
        });
    });
});
exports.selectMarketTemplatesByIds = reselect_1.createSelector(exports.selectMarketTemplateIdsFromProps, exports.selectAllMarketTemplates, function (ids, marketTemplates) {
    return ids
        .map(function (id) { return marketTemplates.get(id); })
        .filter(function (marketTemplate) {
        return !!marketTemplate;
    });
});
var selectCachedMarketStatistic = re_reselect_1.default(exports.selectMarketIdFromProps, exports.selectOddsStatisticMarkets, function (marketId, statisticMarkets) { return statisticMarkets.get(marketId, null); })(exports.selectMarketIdFromProps);
var selectCachedOddsPercentSumInMarket = re_reselect_1.default(selectCachedMarketStatistic, exports.selectOddsStatistic, function (marketStatistic, allStatisticOdds) {
    var statisticOddIds = marketStatistic ? marketStatistic.odds : null;
    if (!statisticOddIds)
        return 0;
    var statisticOdds = statisticOddIds
        .filter(function (oddId) { return allStatisticOdds.has(oddId); })
        .map(function (oddId) { return allStatisticOdds.get(oddId); });
    return lodash_1.sum(statisticOdds.map(function (odd) { return odd.percent; }));
})(exports.selectMarketIdFromProps);
exports.selectStatisticPercentsByMatch = reselect_1.createSelector(exports.selectOddStatistic, function (viewStatisticOdd) { return (viewStatisticOdd ? viewStatisticOdd.percent : null); });
exports.selectStatisticPercentsByMarket = reselect_1.createSelector(selectCachedOddsPercentSumInMarket, exports.selectOddStatistic, function (percentsSum, viewStatisticOdd) {
    if (!viewStatisticOdd || !percentsSum)
        return null;
    var percent = viewStatisticOdd.percent;
    return lodash_1.round((percent * 100) / percentsSum, 2);
});
exports.selectSportsBySportType = reselect_1.createSelector(exports.selectSportTypeFromProps, exports.selectSports, function (sportType, sports) { return utils_1.getSportsBySportType(sports, sportType); });
/** @deprecated Use getSportTypeFromLocation instead */
exports.selectSportTypeFromLocation = reselect_1.createSelector(exports.selectLocationFromProps, function () { return utils_1.getSportTypeFromLocation(); });
// TODO[major]: remove outdated selectSportTypeFromLocation
exports.selectSportTypeBySports = exports.selectSportTypeFromLocation;
var makeSelectSportByEntry = function (selectEntry) {
    return reselect_1.createSelector(selectEntry, exports.selectSports, function (entry, sports) {
        return entry ? sports.get(entry.sportId) : undefined;
    });
};
exports.makeSelectSportByEntry = makeSelectSportByEntry;
exports.selectSportBySportEvent = exports.makeSelectSportByEntry(exports.selectMatch);
exports.selectSportByTournament = exports.makeSelectSportByEntry(exports.selectTournamentByIdFromProps);
exports.selectSportById = reselect_1.createSelector(exports.selectSportIdFromProps, exports.selectSports, function (sportId, sports) { return sports.get(sportId); });
exports.selectSportBySlug = reselect_1.createSelector(exports.selectSlugFromProps, exports.selectSlugs, exports.selectSports, exports.selectMatches, exports.selectTournaments, function (slugId, slugs, sports, sportEvents, tournaments) {
    var _a, _b;
    var slug = slugs.get(slugId) ||
        slugs.find(function (s) { return [s.matchId, s.tournamentId].includes(slugId); });
    if (!slug)
        return;
    var matchId = slug.matchId, tournamentId = slug.tournamentId;
    var sportId;
    if (matchId) {
        sportId = (_a = sportEvents.get(matchId)) === null || _a === void 0 ? void 0 : _a.sportId;
    }
    if (tournamentId) {
        sportId = (_b = tournaments.get(tournamentId)) === null || _b === void 0 ? void 0 : _b.sportId;
    }
    if (!sportId)
        return;
    return sports.get(sportId);
});
exports.selectMissingSportEventIds = reselect_1.createSelector(exports.selectSportEventIdsFromProps, exports.selectMatches, function (sportEventIds, sportEvents) {
    return sportEventIds.filter(function (id) { return !sportEvents.has(id); });
});
var selectMarketIdsFromProps = function (_, props) { return props.marketIds; };
exports.selectMarketIdsFromProps = selectMarketIdsFromProps;
exports.selectMarketsByIds = reselect_1.createSelector(exports.selectMarketIdsFromProps, exports.selectMarkets, function (marketIds, markets) {
    return marketIds
        .map(function (marketId) { return markets.get(marketId); })
        .filter(function (market) { return !!market; });
});
var makeShallowMarketsByIds = function () {
    return exports.createShallowEqualSelector(exports.selectMarketsByIds, function (value) { return value; });
};
exports.makeShallowMarketsByIds = makeShallowMarketsByIds;
exports.selectMarketsWithOddsByIds = reselect_1.createSelector(exports.selectMarketsByIds, exports.selectOdds, function (markets, allOdds) {
    return markets.map(function (market) { return (__assign(__assign({}, market), { odds: market.odds
            .map(function (id) { return allOdds.get(id); })
            .filter(function (odd) { return !!odd; }) })); });
});
var makeSelectShallowMarketsWithOddsByIds = function () {
    return exports.createShallowEqualSelector(exports.selectMarketsWithOddsByIds, function (value) { return value; });
};
exports.makeSelectShallowMarketsWithOddsByIds = makeSelectShallowMarketsWithOddsByIds;
exports.selectMarketTypeIdsByMarketIds = reselect_1.createSelector(exports.makeShallowMarketsByIds(), function (markets) { return markets.map(function (_a) {
    var typeId = _a.typeId;
    return typeId;
}); });
exports.selectTemplatesByIds = reselect_1.createSelector(exports.selectMarketTypeIdsByMarketIds, exports.selectAllMarketTemplates, function (typeIds, marketTemplates) {
    return typeIds
        .map(function (typeId) { return marketTemplates.get(typeId.toString()); })
        .filter(function (marketTemplate) {
        return !!marketTemplate;
    });
});
exports.selectCachedBet = re_reselect_1.default(exports.selectBetIdFromProps, exports.selectBets, function (betId, bets) { return bets.get(betId); })(exports.selectBetIdFromProps);
exports.selectBetCashOutOrder = reselect_1.createSelector(exports.selectAllCashOutOrders, exports.selectCashOutOrderIdFromProps, function (cashOutOrders, cashOutOrderId) {
    return cashOutOrderId ? cashOutOrders.get(cashOutOrderId) : undefined;
});
//# sourceMappingURL=selectors.js.map